import { useReducer } from 'react'

import BankInfo from './BankInfo'
import useValidation from '../useValidation'

const reducer = (state, action) => {
  switch (action.type) {
  case 'setFieldValue':
    return { ...state, [action.field]: action.value }
  default:
    throw new Error('Invalid reducer action')
  }
}

const useBankInfo = ({ i18n, currency, address, ein, paymentOption }) => {
  const [ state, dispatch ] = useReducer(reducer, {
    bankName: '',
    last4: '',
    paymentOption,
  })

  const setPaymentOption = value =>
    dispatch({ type: 'setFieldValue', field: 'paymentOption', value })

  const validation = useValidation({
    i18n,
    currency,
    fieldSet: state.paymentOption == 'wire' && {
      bankName: { required: true, maxLength: 75 },
      last4: {
        required: true,
        minLength: 4,
        maxLength: 4,
        format: { regex: /^\d{4}$/ },
      },
    },
  })

  const render = () =>
    <BankInfo
      i18n={i18n}
      currency={currency}
      paymentOption={state.paymentOption}
      address={address}
      ein={ein}
    />

  return { state, dispatch, validation, setPaymentOption, render }
}

export default useBankInfo
